import { render, staticRenderFns } from "./PlaylistNav.vue?vue&type=template&id=8ac79520"
import script from "./PlaylistNav.vue?vue&type=script&lang=ts"
export * from "./PlaylistNav.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports